export enum PostTypes {
  POST = 'post',
  WORKOUT = 'workout',
  ACTIVITY = 'activity',
}
